import React, { useEffect, useState } from "react";
import MiniStatistics from "../../components/Cards/MiniStatistics";
import { Box, Grid, Typography } from "@mui/material";
import colors from "../../theme";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ElectricBoltSharpIcon from "@mui/icons-material/ElectricBoltSharp";
import { fetchChargingSessionData } from "../../services/api";

const Stats = ({ selectedChargingPoint, switchState}) => {
  const [chargingSessionData, setChargingSessionData] = useState({
    energyConsumed: 0,
    energyRate: 0,
    totalEnergyCost: 0,
    startedAt: null,
    endedAt: null,
  });
  const [duration, setDuration] = useState("");

  useEffect(() => {
    const getChargingSessionData = async () => {
      try {
        const data = await fetchChargingSessionData(selectedChargingPoint);
        setChargingSessionData(data.data);
      } catch (error) {
        console.error("Error fetching charging session data:", error);
        if (error.response?.data?.status === "0304") {
          setChargingSessionData({
            energyConsumed: 0,
            energyRate: 0,
            totalEnergyCost: 0,
            startedAt: null,
            endedAt: null,
          });
        }
      }
    };

    if (selectedChargingPoint) {
      
      let intervalId;

      const initialIntervalId = setTimeout(() => {
        getChargingSessionData();
        if(switchState)
        {
          intervalId = setInterval(getChargingSessionData, 20000);
        }
      }, 5000);

      return () => {
        clearTimeout(initialIntervalId);
        clearInterval(intervalId);
      };
    }
  }, [selectedChargingPoint, switchState]);

  useEffect(() => {
    const calculateDuration = (start, end) => {
      const startTime = new Date(start);
      const endTime = end ? new Date(end) : new Date();
      const durationMs = endTime - startTime; // Difference in milliseconds

      if (isNaN(durationMs)) return null;

      const hours = Math.floor(durationMs / (1000 * 60 * 60));
      const minutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));

      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}`;
    };

    if (chargingSessionData.startedAt) {
      const calculatedDuration = calculateDuration(
        chargingSessionData.startedAt,
        chargingSessionData.endedAt
      );
      setDuration(calculatedDuration);
    }
  }, [chargingSessionData]);

  const statsData = [
    {
      statsIcon: <ElectricBoltSharpIcon />,
      name: "Consumption",
      value: `${(chargingSessionData.energyConsumed / 1000).toFixed(2)} kWh`,
    },
    {
      statsIcon: <AttachMoneyIcon />,
      name: "Rate",
      value: `$${chargingSessionData.energyRate} /kWh`,
    },
    {
      statsIcon: <AttachMoneyIcon />,
      name: "Total",
      value: `$${Number(chargingSessionData.totalEnergyCost).toFixed(2)}`,
    },
  ];

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 0.5,
        }}
      >
        <Typography sx={{ fontWeight: "bold" }}>Duration: </Typography>
        <Typography sx={{ marginLeft: 1 }}>{duration || "00:00"}</Typography>
      </Box>
      <Box
        sx={{
          backgroundColor: colors.mainContentBgColor,
          paddingX: 2,
          paddingBottom: 0.5,
        }}
      >
        <Grid container spacing={2}>
          {statsData.map((stat, index) => (
            <Grid item xs={4} sm={4} key={index}>
              <MiniStatistics
                name={stat.name}
                value={stat.value}
                icon={stat.statsIcon}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default Stats;
